import * as Sentry from "@sentry/react";
import { BUILD_VERSION } from "../buildInfo";

function numericEnv(name, fallback) {
  const parsed = Number(process.env[name]);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function initializeSentry() {
  const dsn = String(process.env.REACT_APP_SENTRY_DSN || "").trim();
  if (!dsn) return false;

  Sentry.init({
    dsn,
    environment:
      process.env.REACT_APP_SENTRY_ENVIRONMENT ||
      process.env.NODE_ENV ||
      "development",
    release: process.env.REACT_APP_SENTRY_RELEASE || `housemind-frontend@${BUILD_VERSION}`,
    sendDefaultPii: false,
    tracesSampleRate: numericEnv("REACT_APP_SENTRY_TRACES_SAMPLE_RATE", 0.05),
    // Keep the initial rollout privacy- and quota-conscious. Session Replay can
    // be enabled later after consent, retention, and masking are reviewed.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    beforeSend(event) {
      if (event.user) {
        event.user = event.user.id ? { id: event.user.id } : undefined;
      }
      if (event.request) {
        delete event.request.cookies;
        delete event.request.data;
        if (event.request.headers) {
          delete event.request.headers.Authorization;
          delete event.request.headers.authorization;
          delete event.request.headers.Cookie;
          delete event.request.headers.cookie;
        }
      }
      return event;
    },
  });
  return true;
}

export function captureBoundaryError(error, info) {
  if (!Sentry.isInitialized()) return;
  Sentry.withScope((scope) => {
    scope.setContext("react", {
      componentStack: info?.componentStack || "",
    });
    Sentry.captureException(error);
  });
}
